import { Component } from '@angular/core';
import { IDateAngularComp } from 'ag-grid-angular';
import { IDateParams } from 'ag-grid-community';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-custom-date-filter',
  template: `
    <form [formGroup]='dateFormGroup'>
      <pt-input-time-date-picker
        [lang]='translate.currentLang'
        [readOnlyInput]='true'
        [withClearButton]='true'
        [roundedBorder]='false'
        [inputWidth]='105'
        [liteVersion]='true'
        [bodyContainer]='true'
        [hideTimePicker]="true"
        formControlName='date'
        class='w-100'
      ></pt-input-time-date-picker>
    </form>
  `,
  styles: [`
    pt-custom-date-filter {
      width: 100%;
    }
  `]
})
export class CustomDateFilterComponent implements IDateAngularComp {
  public dateFormGroup: FormGroup;
  private params: IDateParams;

  constructor(public translate: TranslateService) {
    this.dateFormGroup = new FormGroup({
      date: new FormControl()
    });

    this.dateFormGroup.controls.date.valueChanges.subscribe((d) => {
      this.params.onDateChanged();
    });
  }


  agInit(params: IDateParams): void {
    this.params = params;
  }

  getDate(): Date | null {
    return new Date(this.dateFormGroup.controls.date.value);
  }

  setDate(date: Date | null): void {
    if (date) {
      this.dateFormGroup.controls.date.setValue(date.getTime());
    }
  }

}
